import {
  Text,
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
} from '@kanda-libs/ks-design-library';
import StaffImitateUserForm from './StaffImitateUserForm';

const Staff = () => (
  <DesktopLayoutBoxed>
    <DesktopLayoutBoxedContent>
      <Text className="mb-4 text-20-24-em" text="Staff portal" />
      <StaffImitateUserForm />
    </DesktopLayoutBoxedContent>
  </DesktopLayoutBoxed>
);

export default Staff;
